import {
	Component, Input, Output, EventEmitter, SimpleChanges, OnDestroy,
	ViewChild
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { UntypedFormBuilder, FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { SchedDiscConfigComponentBase } from "../SchedDiscConfigComponentBase";
import { NetFacadeService } from 'netview';
import { SchedDiscPrtgExport } from 'DiscoveryEngine.TS/PRTG';
import { PrtgExportConfigComponent } from '../prtg-export-config/prtg-export-config.component';


@Component({
	selector: 'sched-disc-config-prtg',
	templateUrl: './sched-disc-config-prtg.component.html',
	styleUrls: ['./sched-disc-config-prtg.component.scss']
})
export class SchedDiscConfigPrtgComponent extends SchedDiscConfigComponentBase {

    @ViewChild(PrtgExportConfigComponent, { static: true })
	private PrtgExportComp: PrtgExportConfigComponent;

	private static NullPrtgExport = new SchedDiscPrtgExport();

	public get PrtgExport(): SchedDiscPrtgExport {
		if (this.Discovery)
			return this.Discovery.PrtgExport;
		else
			return SchedDiscConfigPrtgComponent.NullPrtgExport;
	}

	constructor(private fb: UntypedFormBuilder, netFacadeService: NetFacadeService) {
		super(netFacadeService);
	}

	protected BuildForm(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.onChanges();
	}

	public get tempChanges(): boolean {
		return this.PrtgExportComp.tempChanges;
	}

	public get tempChangesValid(): boolean {
		return this.PrtgExportComp.tempChangesValid;
	}

	public applyTempChanges(): void {
		this.PrtgExportComp.applyTempChanges();
		this.onApplyTempChanges();
	}

	public get invalidTempChanges(): string[] {
		return this.PrtgExportComp.invalidTempChanges;
	}

	public discardTempChanges(): void {
		this.PrtgExportComp.discardTempChanges();
	}

}
